import { getBaseUrl } from './ServiceUtils';
import appRequest from './appRequest';

const LOGS_URL = getBaseUrl('/logs/');

export async function getLogs(file) {
    return await appRequest.doGetRequest(`${LOGS_URL}${file}`);
}

export async function clearLog(file) {
    return await appRequest.doDeleteRequest(`${LOGS_URL}${file}`);
}

export async function getLogsList(userId, page, size) {
    const params = new URLSearchParams({ page, userId: userId || '' });
    if (size) params.set('pageSize', size);
    return await appRequest.doGetRequest(`${LOGS_URL}?${params}`);
    /*
    return new Promise((resolve, reject) => {
        const logsList = ['M_1.log', 'M_2.log'];
        resolve({rows: logsList, count: logsList.length});
    });
    */
}